// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fZ7II","image":"styles_image__A5pKb","hints":"styles_hints__hg0lY","description":"styles_description__LBSWh"};